import { Card, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Button from "../../../Components/Button"
import InfoTooltip from "../../../Components/InfoTooltip/InfoTooltip"
import Icon from "../../../Icon"

// Boxed dashboard section using the EXACT Prevent chart-card style
// (.card-chart-wrapper.withTitle: radius 24, head padding 24, headerless border).
// title goes in the card head (left), optional control as `extra` (right).
// `autoHeight` opts out of the stretch: the card ends where its content ends, instead of
// growing to match the taller card beside it. Use it where the content has its own natural
// height (a short bar list, a 5-row heat map) and the filler space read as a bug.
// `onViewAll` adds the section's "View All": a link in the head on desktop and, as on Prevent's
// Analytics, a full-width button under the content on a phone.
const Section = ({
  title,
  tooltip,
  extra,
  onViewAll,
  children,
  minHeight,
  autoHeight,
  className = ""
}) => {
  const { t } = useTranslation()
  const isMobile = useSelector((s) => s.nav.isMobile)

  const viewAllLink =
    onViewAll && !isMobile ? (
      <Button
        type="link"
        onClick={onViewAll}
        icon={<Icon type="chevron_right_small" />}
        iconPosition="end"
        style={{ padding: 0 }}
        size="small"
        text={t("View All")}
      />
    ) : undefined
  // A section with its own control (a By count / By volume toggle) keeps it beside the link.
  const headExtra =
    extra && viewAllLink ? (
      <Flex align="center" gap={12} wrap="wrap">
        {extra}
        {viewAllLink}
      </Flex>
    ) : (
      (extra ?? viewAllLink)
    )

  return (
    <Card
      className={`card-chart-wrapper withTitle ${className}`.trim()}
      styles={{ header: { border: "none" } }}
      // height:100% + the page Row align="stretch" makes paired 2-up cards equal
      // height (matching Alerts Analytics), even when one has less content.
      style={{ ...(autoHeight ? {} : { height: "100%" }), ...(minHeight ? { minHeight } : {}) }}
      title={
        tooltip ? (
          <Flex align="center" gap={8}>
            <span>{title}</span>
            <InfoTooltip title={tooltip} placement="top" />
          </Flex>
        ) : (
          title
        )
      }
      extra={headExtra}
    >
      {children}
      {onViewAll && isMobile && (
        <Button
          height="40"
          // flexShrink: a section whose body is a flex column (Top countries) must not squeeze it.
          style={{ width: "100%", marginTop: 18, flexShrink: 0 }}
          onClick={onViewAll}
          text={t("View all")}
        />
      )}
    </Card>
  )
}

export default Section
